var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import { overlayStyle, iframeStyle } from './styles';
import getStackFrames from './utils/getStackFrames';

import RuntimeErrorContainer from './containers/RuntimeErrorContainer';
var editorHandler = null;

function setEditorHandler(handler) {
  editorHandler = handler;
}

var OuterWrapper = function OuterWrapper(_ref) {
  var children = _ref.children;
  return React.createElement(
    'div',
    { style: iframeStyle },
    React.createElement(
      'div',
      { style: overlayStyle },
      children
    )
  );
};

var ErrorBoundaryComponent = function (_React$PureComponent) {
  _inherits(ErrorBoundaryComponent, _React$PureComponent);

  function ErrorBoundaryComponent() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ErrorBoundaryComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ErrorBoundaryComponent.__proto__ || Object.getPrototypeOf(ErrorBoundaryComponent)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      currentRuntimeErrorRecords: []
    }, _this.dismissRuntimeErrors = function () {
      _this.setState({
        currentRuntimeErrorRecords: []
      });
    }, _this.handleRuntimeError = function (errorRecord) {
      var currentRuntimeErrorRecords = _this.state.currentRuntimeErrorRecords;


      if (currentRuntimeErrorRecords.some(function (_ref3) {
        var error = _ref3.error;
        return error === errorRecord.error;
      })) {
        // Deduplicate identical errors.
        // This fixes https://github.com/facebook/create-react-app/issues/3011.
        return;
      }

      currentRuntimeErrorRecords = currentRuntimeErrorRecords.concat([errorRecord]);

      _this.setState({
        currentRuntimeErrorRecords: currentRuntimeErrorRecords
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ErrorBoundaryComponent, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      var _this2 = this;

      getStackFrames(error, false, 3).then(function (stackFrames) {
        if (stackFrames == null) {
          return;
        }

        _this2.handleRuntimeError({
          error: error,
          unhandledRejection: false,
          contextSize: 3,
          stackFrames: stackFrames
        });
      }).catch(function (e) {
        console.log('Could not get the stack frames of error:', e);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var currentRuntimeErrorRecords = this.state.currentRuntimeErrorRecords;


      if (currentRuntimeErrorRecords.length > 0) {
        return React.createElement(
          OuterWrapper,
          null,
          React.createElement(RuntimeErrorContainer, {
            errorRecords: currentRuntimeErrorRecords,
            close: this.dismissRuntimeErrors,
            editorHandler: editorHandler
          })
        );
      }

      return this.props.children;
    }
  }]);

  return ErrorBoundaryComponent;
}(React.PureComponent);

export default ErrorBoundaryComponent;